import React from 'react';
import BaseFaq from 'components/Faq';

export default function Faq() {
  return (
    <BaseFaq
      items={[
        {
          question: "Who can enjoy Mind the Graph's 10th anniversary offer?",
          answer:
            'This special offer is available for new subscribers and Students subscribers who wish to make an upgrade.',
        },
        {
          question: 'How long does the 10th anniversary campaign last?',
          answer: 'The 10th anniversary campaign goes from 01/02/2024 until 29/02/2024',
        },
        {
          question: 'What payment method can I use to subscribe?',
          answer: 'You can subscribe using a credit card.',
        },
        {
          question: 'What is a custom Graphical Abstract?',
          answer:
            'A custom Graphical Abstract is an infographic made by our design team upon your request to be submitted to scientific journals. Also suitable for papers, books and press releases.',
        },
        {
          question: 'Until when can I claim my free custom Graphical Abstract?',
          answer:
            'You can request your free Graphical Abstract at any time after confirming your annual subscription. You have within a year to request it and the delivery deadline will be informed as soon as possible.',
        },
        {
          question: 'What is an annual Researcher subscription?',
          answer:
            "The annual researcher subscription is a plan in which you can enjoy all Mind the Graph's premium benefits for a whole year. The annual subscription is paid once a year on your credit card, and after the billing, you can use the tool freely for the next 12 months.",
        },
        {
          question: 'How does the annual subscription work?',
          answer:
            "After confirming your payment details, the special price of 99 USD will be charged to your credit card. Then you can enjoy Mind the Graph's benefits for the next 12 months. Renewal is automatic and after the first year you will be charged the regular price of 144 USD.",
        },
      ]}
    />
  );
}
